import { render, staticRenderFns } from "./TheSidebar.vue?vue&type=template&id=6aac0242&"
import script from "./TheSidebar.vue?vue&type=script&lang=ts&"
export * from "./TheSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./TheSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports